import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["table"]

  toggle(event) {
    const id = event.currentTarget.dataset.messageId

    this.tableTargets.forEach(target => {
      if (target.dataset.messageId === id) target.classList.toggle("d-none");
    })
  }
}
